import React from 'react';
import { defaultFormText } from 'src/components/common/common';

interface DropDownOptionItemProps {
  itemKey: string | number;
  label: string;          // 사용자에게 보여질 텍스트
  isSelected: boolean;
  onSelect: () => void;   // 옵션 선택 시 호출될 함수
}

export const DropDownOptionItem: React.FC<DropDownOptionItemProps> = ({
  itemKey,
  label,
  isSelected,
  onSelect,
}) => {
  return (
    <li
      key={itemKey}
      onClick={onSelect}
      className={`px-3 py-1 hover:bg-gray-100 cursor-pointer truncate ${defaultFormText}`}
      role="option"
      aria-selected={isSelected}
      title={label}
    >
      {label}
    </li>
  );
};